import React, { createContext, use, useEffect, useState } from 'react';

interface IIsMobileContext {
  isMobile: boolean;
}

const IsMobileContext = createContext<IIsMobileContext>({
  isMobile: false,
});

export const IsMobileProvider = ({ children }: { children: React.ReactNode }) => {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.matchMedia('(max-width: 768px)').matches);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  return <IsMobileContext value={{ isMobile }}>{children}</IsMobileContext>;
};

export const useIsMobile = () => {
  return use(IsMobileContext);
};
